import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DatePicker } from "src/components/Default/Calendar/DatePicker";

import DefaultFilters from "../../DefaultFilters";
import Progress, { maxQuestionPerDay } from "./Progress";

export function DateFilter({
	courseDetails,
	setDetails,
	queryLength,
	...props
}) {
	const { t } = useTranslation();
	const [expanded, setExpanded] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);

	const open = Boolean(anchorEl);
	const id = open ? "calendar" : undefined;

	const getFinishedDate = useCallback(
		(count = courseDetails.questionsPerDay) => {
			const minDaysCount = Math.ceil(queryLength / maxQuestionPerDay) - 1;
			const minDate = dayjs().add(minDaysCount, "days");
			const countOfDayToResolve = queryLength / count;
			const now = dayjs();

			const finishedDate = now.add(Math.ceil(countOfDayToResolve) - 1, "day");
			return minDate > finishedDate ? minDate : finishedDate;
		},
		[courseDetails.questionsPerDay, queryLength],
	);

	const getQuestionPerDay = (date = courseDetails.endDate) => {
		const endDate = dayjs(date);
		const now = dayjs();
		const diff = Math.ceil(endDate.diff(now, "days", true));
		const countOfDayToResolve = Math.ceil(queryLength / (diff + 1));
		return Number.isNaN(diff) ? 0 : Math.max(countOfDayToResolve, 1);
	};

	const setQuestionsPerDay = (count) => {
		setDetails({ questionsPerDay: count, endDate: getFinishedDate(count) });
	};

	const setEndDate = (date) => {
		setDetails({ questionsPerDay: getQuestionPerDay(date), endDate: date });
		setAnchorEl(null);
		setExpanded(true);
	};

	const renderFilters = () => {
		return (
			<div>
				<Progress
					queryLength={queryLength}
					questionsPerDay={courseDetails.questionsPerDay}
					setDetails={setQuestionsPerDay}
				/>
			</div>
		);
	};

	const getCalendarButton = () => {
		const minDaysCount = Math.ceil(queryLength / maxQuestionPerDay) - 1;

		return (
			<DatePicker
				setDate={setEndDate}
				date={courseDetails.endDate}
				minDate={dayjs().add(minDaysCount, "days")}
				renderTrigger={({ setAnchor }) => (
					<Button
						className="px-4 py-0"
						aria-describedby={id}
						onClick={setAnchor}
					>
						{dayjs(courseDetails.endDate).format("DD-MM-YYYY")}
					</Button>
				)}
			/>
		);
	};

	const getTitle = () => {
		return <span>{t("filters.courses.date.endDate")}</span>;
	};

	return (
		<div className={props.className} data-test-id="date-filter-section">
			<DefaultFilters
				{...props}
				expanded={!open && expanded}
				title={getTitle()}
				renderFilterDetails={renderFilters}
				onChange={() => setExpanded(!expanded)}
				disabled={queryLength === 0}
				actions={getCalendarButton()}
			/>
		</div>
	);
}

export default styled(DateFilter)``;
